import { createContext } from "react";

const LinkContext = createContext();

export default LinkContext;
